import { BreadcrumbLinkProps } from "@chakra-ui/react";

export class BreadcrumbsBuilder {
  constructor(private sections: BreadcrumbLinkProps[] = []) {
    return this;
  }

  public addSection(section: BreadcrumbLinkProps | null | undefined) {
    if (section) this.sections.push(section);
    return this;
  }

  public build() {
    return this.sections;
  }
}
